import React from "react";
import * as S from "./styles";
import * as T from "./types";
import { Context } from "@routes/private/Editor/Context";
import CopyMenuIcon from "@assets/icons/copyMenuIcon";
import ClickOutside from "@components/ClickOutside";
import EditIcon from "@assets/icons/editIcon";
import DeleteIcon from "@assets/icons/deleteIcon";
import SetsMenuScreen from "../SetsMenuScreen";
import { getSetNameForClipboard } from "@utils/sets";

const SetsMenu: React.FC<T.IProps> = (props) => {

  const context = React.useContext(Context);
  const [setName, setSetName] = React.useState("");
  const [screenProps, setScreenProps] = React.useState<T.IScreenProps>({opened: false});

  const handleCopySet = (name?: string) => {
    context.onCommandChange("copypaste", {copy: true, paste: true, setName: name});
  }

  const handleEditSet = (name?: string) => {
    context.onCommandChange("editName", name);
    handleCloseScreen();
  }

  const handleDeleteSet = () => {
    context.onCommandChange("removeElement", {selectedSetName: props.selectedSetName, setNames: props.setNames});
    handleCloseScreen();
  }

  const handleOpenScreen = (action: T.ScreenActions) => {
    let newScreenProps: T.IScreenProps = {opened: true, id: action};
    if (action === "copy") {
        setSetName(getSetNameForClipboard(props.title, props.setNames));
        newScreenProps.title = "Name New Set";
        newScreenProps.description = "Enter unique name of the set that you’ve created. If you click cancel, the set will not be created.";
        newScreenProps.actionTitle = "CREATE SET";
        newScreenProps.action = handleCopySet;
    } else if (action === "edit") {
        setSetName(props.title);
        newScreenProps.title = "Edit Set";
        newScreenProps.description = "Edit the name for your set.";
        newScreenProps.actionTitle = "EDIT SET";
        newScreenProps.action = handleEditSet;
    } else if (action === "delete") {
        newScreenProps.title = "Delete Set";
        if (props.setNames.length === 1) {
          newScreenProps.description = "Each template must have at least one set. You cannot delete this set.";
          newScreenProps.actionTitle = "OKAY";
          newScreenProps.action = undefined;
        } else {
          newScreenProps.description = "Are you sure you want to remove this set? If so, you will not be able to access it again.";
          newScreenProps.actionTitle = "DELETE SET";
          newScreenProps.action = handleDeleteSet;
        }
    }
    setScreenProps({...newScreenProps});
  }

  const handleCloseScreen = () => {
    setScreenProps({opened: false});
  }

  return (
    <ClickOutside
      onClickOutside={props.handleClose}
      event="mousedown"
    >
      {
        screenProps.opened &&
        <SetsMenuScreen
          editNameState={[setName, setSetName]}
          currentName={props.title}
          setNames={props.setNames}
          screenProps={screenProps}
          handleCloseParent={props.handleClose}
          handleClose={handleCloseScreen}
        />
      }
      <S.Root>
        <S.Title>
          {props.title}
        </S.Title>
        <S.OptionRow
          onClick={() => handleOpenScreen("copy")}
        >
          <S.OptionIcon>
            <CopyMenuIcon />
          </S.OptionIcon>
          <S.OptionLabel>
            Create a Copy
          </S.OptionLabel>
        </S.OptionRow>
        <S.OptionRow
          onClick={() => handleOpenScreen("edit")}
        >
          <S.OptionIcon>
            <EditIcon />
          </S.OptionIcon>
          <S.OptionLabel>
            Edit Name
          </S.OptionLabel>
        </S.OptionRow>
        <S.Divider />
        <S.OptionRow
          onClick={() => handleOpenScreen("delete")}
        >
          <S.OptionIcon>
            <DeleteIcon />
          </S.OptionIcon>
          <S.OptionLabel>
            Delete Set
          </S.OptionLabel>
        </S.OptionRow>
      </S.Root>
    </ClickOutside>
  );
}

export default SetsMenu;